module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.ab11bd53.svg";